import { DELETE_LIST_ITEMS_START } from '../../types';

export const delete_list_items = (payload) => ({
  type: DELETE_LIST_ITEMS_START,
  payload,
});
